import React from 'react';

function NoTermSelected() {
	return <div>NoTermSelected</div>;
}

export default NoTermSelected;
